import axios from "axios";
import Cookies from "js-cookie";
import { Contract, ID } from "models";

export const editContract = ({ id, contract }: { id: ID; contract: Contract }) => {
  return axios
    .put(`/api/v1/contract/${id}/`, contract, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then((res) => {
      return res;
    });
};
